import React,{useEffect} from 'react'
import { useState } from 'react';
import { useMutation } from '@apollo/client';
import { Form, Input, Select, Button, Skeleton } from 'antd';
import { Options } from '../Constants/Option';
import '../Styles/UpdateWallpaper.css'
import { useHistory, useParams } from 'react-router-dom';
import useWallpaper from '../../util/useWallpaper';
import { UPDATE_WALLPAPER } from '../GraphQL/Mutations';
import { GET_WALLPAPERS } from '../GraphQL/Queries';
import { useContext } from 'react';
import { AuthContext } from '../../context/auth';

const { TextArea } = Input;

function UpdateWallpaper(username) {
  const { user } = useContext(AuthContext);
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [category, setCategory] = useState('');
  const [image, setImage] = useState('');
  const [load, setLoad] = useState(false);

  let history = useHistory();
  const { id } = useParams();

  const [updateWall] = useMutation(UPDATE_WALLPAPER);

  useEffect(() => {
    return () => {
      
      setLoad(false);
    };
  }, []);


  const handleUpdate = async (e) => {
   // e.preventDefault();
    setLoad(true);
    try {

      if (!image)  {
        return alert('Please upload an image first');  
      } 

      
      const res = await updateWall({
        variables: { wallpaperId: id, image, title, category, description, username },
        refetchQueries: [{ query: GET_WALLPAPERS }],
      });
      if (res.data) {
        alert('Wallpaper Updated Successfully');
        history.push('/');
      }
      
    } catch (err) {
      console.error(err);
    }
    finally {
      setLoad(false);
    }
  };

  const { data, loading, error } = useWallpaper(id);

  if (error) return <div>something went wrong!</div>;
  if (loading)
    return (
      <div>
        <Skeleton active />
        <Skeleton active />
      </div>
    );

  return (
    <>
      <div className="container">
        {loading && <div>loading...</div>}
        <h1>Update Wallpaper</h1>
        <Form layout="vertical" noValidate>
          <Form.Item label="Title">
            <Input
              type="text"
              defaultValue={data.getWallpaper.title}
              placeholder="Enter Title"
              onChange={(e) => setTitle(e.target.value)}
            />
          </Form.Item>
          <Form.Item label="Category">
            <Select
              defaultValue={data.getWallpaper.category}
              onChange={(e) => setCategory(e)}
            >
              <Select.Option disabled value="">
                Please Select Category
              </Select.Option>
              {Options.map((option) => {
                return (
                  <Select.Option value={option} key={option}>
                    {option}
                  </Select.Option>
                );
              })}
            </Select>
          </Form.Item>
          <Form.Item label="Description">
            <TextArea
              defaultValue={data.getWallpaper.description}
              placeholder="Enter Description"
              onChange={(e) => setDescription(e.target.value)}
            />
          </Form.Item>
          <Form.Item label="Wallpaper">
            <Input
              type="file"
              accept='image/*'
              onChange={(e) => setImage(e.target.files[0])}
            />
          </Form.Item>
          <Form.Item>
          {user && user.username === data.getWallpaper.username && (
            <Button
              type="primary"
              htmlType="submit"
              loading={load}
              onClick={handleUpdate}
            >
              Save
            </Button>
            )}
          </Form.Item>
        </Form>
      </div>
    </>
  );
}

export default UpdateWallpaper;





